module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-152x152-ee158c54b7770431082732db5843bdd9.png";